import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IProvider } from 'src/app/core/models/amazon-ads-config';
import { map, tap } from 'rxjs/operators';
import { PeriodType, SubscriptionStatus } from 'src/app/routes/subscriptions/subscriptions-detail';
import { ISubscription } from '../../models/subscription';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProviderService {
  private readonly url = '/api/providers';
  private currentProvider$!: BehaviorSubject<IProvider>;

  constructor(private http: HttpClient) {}

  getByCompanyId(companyId: string) {
    return this.http.get<IProvider>(`${this.url}/${companyId}`);
  }

  getCurrentProviderByCompanyId(companyId: string){
    return this.http.get<IProvider>(`${this.url}/${companyId}`)
    .pipe(
      tap(provider => {
        this.updateCurrentProvider(provider);
      })
    );
  }

  getCurrentProvider(): Observable<IProvider>{
    return this.currentProvider$.asObservable();
  }

  updateCurrentProvider(provider: IProvider){
    this.currentProvider$.next(provider)
  }

  getSubscriptionByCompanyId(companyId: string) {
    return this.getByCompanyId(companyId).pipe(
      map(({ subscription }) => {
        const sub: ISubscription = {
          id: null,
          customer: null,
          status: null,
          trial_start: null,
          trial_end: null,
          current_period_start: null,
          current_period_end: null,
          cancel_at_period_end: false,
          plan: null,
          metadata: {},
          default_payment_method: null,
        };

        if (!subscription) return sub;

        if(subscription.id){
          sub.customer = 'CUSTOMER_EMPTY';
        }

        if(subscription.status){
          sub.status = subscription?.status.toLowerCase() as SubscriptionStatus;
        }

        if(subscription.metadata){
          if(subscription.metadata?.trialEndAt){
            sub.trial_end = new Date(subscription.metadata.trialEndAt).getTime() / 1000;
          }

          if(subscription.metadata?.periodEndAt){
            sub.current_period_end = new Date(subscription.metadata.periodEndAt).getTime() / 1000;
          }
          
          sub.plan = {
            id: 'PLAN_ACTIVE',
            active: true,
            interval: subscription?.metadata?.period
              ?.replace('ly', '')
              ?.toLowerCase() as PeriodType,
            fullInterval: subscription?.metadata?.period,
            name: subscription?.metadata?.name ?? '',
            amount: subscription?.metadata?.price ?? 0,
            trial_period_days: subscription?.metadata?.trialDays ?? 0,
          }

          sub.default_payment_method = 'pm_1RUJM5I6T0YnBkmyynViJKuF'
        }

        return sub;
      })
    );
  }

  deleteProvider(companyId: string, deleteType: string) {
    return this.http.delete(`${this.url}/${companyId}`, {
      params: {
        type: 'postgres',
        deleteType,
      },
    });
  }
}
